import { Session } from '~/types/tutoring-api'

import useGetCompletedSessions from './useGetCompletedSessions'

export default function useGetNonRatedSession(): Session | undefined {
  const completedSessions = useGetCompletedSessions()
  const nonRatedSessions = completedSessions?.filter((elem) => elem.studentRating === null)

  if (nonRatedSessions && nonRatedSessions.length > 0) {
    return nonRatedSessions[0]
  }
}
